module.exports = __webpack_public_path__ + "static/media/pay_crypto.a71e0c33.svg";